import React, { useState, useEffect } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { Link } from "react-router-dom";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import { db } from "../firebaseConfig";
import "../css/TalkPage.css";

function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
}

function getRandomAccent() {
    const accents = ["accent-gold", "accent-blue", "accent-rose", "accent-teal", "accent-orange", "accent-purple", "accent-cyan", "accent-green"];
    return accents[Math.floor(Math.random() * accents.length)];
}

function getRandomBlobPos() {
    const positions = ["blob-top-left", "blob-top-right", "blob-bottom-left", "blob-bottom-right", "blob-center"];
    return positions[Math.floor(Math.random() * positions.length)];
}

export default function TalksGrid() {
    const [talks, setTalks] = useState([]);
    const [search, setSearch] = useState("");

    useEffect(() => {
        async function fetchPublished() {
            const q = query(
                collection(db, "talks"),
                where("status", "==", "Published")
            );
            const snap = await getDocs(q);
            setTalks(snap.docs.map(d => ({ id: d.id, ...d.data() })));
        }
        fetchPublished();
    }, []);

    const filtered = talks.filter(t =>
        t.title?.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <>
            <Navbar />
            <main className="talks-grid-page">
                <div className="talks-grid-header">
                    <h1>Published Talks</h1>
                    <input
                        type="text"
                        placeholder="Search talks..."
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                    />
                </div>
                {filtered.length > 0 ? (
                    <div className="talks-grid">
                        {filtered.map(talk => (
                            <Link key={talk.id} to={`/talk/${talk.id}`} className={`talk-card ${getRandomAccent()} ${getRandomBlobPos()}`}>
                                <div className="talk-title">{talk.title}</div>
                            </Link>
                        ))}
                    </div>
                ) : (
                    <p className="no-talks-message">
                        No talks found. More are on the way — stay tuned!
                    </p>
                )}
            </main>
            <Footer />
        </>
    );
}
